module.exports = __webpack_public_path__ + "img/vip@2x.adf79923.png";